/* RESPONSIBLE TEAM: team-workflows */

export type AudienceMode = 'everyone' | 'custom' | 'fin_audience';

export const AUDIENCE_MODES = {
  EVERYONE: 'everyone' as const,
  CUSTOM: 'custom' as const,
  FIN_AUDIENCE: 'fin_audience' as const,
} as const;

export class AudienceModeManager {
  private isCustomModeActive = false;

  constructor(private ruleset: any) {}

  setCustomModeActive(active: boolean): void {
    this.isCustomModeActive = active;
  }

  getCurrentMode(selectedSegmentIds: number[]): AudienceMode {
    // Segments always take precedence
    if (selectedSegmentIds.length > 0 || this.ruleset?.segmentIds?.length > 0) {
      return AUDIENCE_MODES.FIN_AUDIENCE;
    }

    // If custom mode is explicitly active (user clicked custom), stay in custom
    if (this.isCustomModeActive) {
      return AUDIENCE_MODES.CUSTOM;
    }

    // If there are regular predicates, it's custom
    if (this.ruleset.predicateGroup?.predicates?.length > 0) {
      return AUDIENCE_MODES.CUSTOM;
    }

    // If there are role predicates but NOT the "everyone" combination, it's custom
    if (this.ruleset.rolePredicateGroup?.predicates?.length > 0) {
      if (!this.isEveryoneRolePredicate()) {
        return AUDIENCE_MODES.CUSTOM;
      }
    }

    // Default to everyone (new workflows OR workflows with "everyone" role predicate)
    return AUDIENCE_MODES.EVERYONE;
  }

  private isEveryoneRolePredicate(): boolean {
    let rolePredicates = this.ruleset.rolePredicateGroup?.predicates;
    if (!rolePredicates || rolePredicates.length !== 1) {
      return false;
    }

    let rolePredicate = rolePredicates.objectAt(0);
    if (!rolePredicate?.value || !Array.isArray(rolePredicate.value)) {
      return false;
    }

    // Check if all three roles are present
    let expectedRoles = ['contact_role', 'user_role', 'visitor_role'];
    let actualRoles = [...rolePredicate.value].sort();
    expectedRoles.sort();

    return (
      actualRoles.length === 3 && actualRoles.every((role, index) => role === expectedRoles[index])
    );
  }
}
